// stores/medication-selection.ts
import { create } from 'zustand';

type MedicationSelectionState = {
  id1: string 
  id2: string 
  isReady: boolean
  setIds: (id1: string, id2: string) => void;
  closeIsReady: () => void;
  reset: () => void;
  setIsReady: (isReady: boolean) => void;
};

export const useMedicationSelectionStore = create<MedicationSelectionState>((set) => ({
  id1: "",
  id2: "",
  isReady: false,
  setIds: (id1, id2) => set({ id1, id2, isReady:true }),
  closeIsReady:() =>  set({isReady:false  }),
  setIsReady: (isReady) => set({ isReady }),
  reset: () => set({ id1: "", id2: "" }),
}));
